<template>
	<RPBasicCardVue
		:isheader="false"
	>
   <span slot="header"> </span>
	<el-form
		slot="body"
		class="rp-helpcenter-code-form"
		:model="codeForm"
		:rules="validationRules"
		ref="codeForm"
		@submit.native.prevent
		:hide-required-asterisk="true"
		>
		<div
			class="rp-helpcenter-code-form__suggestion-text"
			>
			{{ $t('loginScreen.enterCode')}}
		</div>
		<div
			class="rp-helpcenter-code-form__suggestion-text bold"
			>
			{{ userIdType === 'phone' ?  phoneCode : '' }}{{ userLoginId }}
		</div>
		<el-form-item>
			<LoginFormSuggestionSection
				@click="clickedOnChange"
				:suggestionText="$t('loginScreen.notYourUserId', { userIdType: $t(`loginScreen.userIdTypes.${userIdType}`)})"
				:ctaText="$t('loginScreen.change')"
				marginForLabel="0rem 0rem 0rem 0rem"
				:ctaDisabled="canDisableTheFormFields"
			/>
		</el-form-item>
		<el-form-item
			prop="code"
			>
			<el-collapse-transition>
				<rp-otp-input
					v-if="!resetInput"
					:numInputs="4"
					:shouldAutoFocus="true"
					@on-complete="codeEntered"
					:isInputNum="true"
					:disabled="canDisableTheFormFields"
				/>
			</el-collapse-transition>
		</el-form-item>

		<el-form-item>
			<LoginFormSuggestionSection
				@click="clickedOnResend"
				:suggestionText="$t('loginScreen.notReceivedCode')"
				:ctaText="ctaTextForResendCodeSuggestion"
				marginForLabel="0rem 0rem 0rem 0rem"
				:ctaDisabled="timeLeftForResend>0 || canDisableTheFormFields"
			/>
		</el-form-item>
		<el-form-item>
			<RPSecondaryCTA
				:label="$t(`loginScreen.verifyCode`)"
				class="small"
				@click="verifyCode('codeForm')"
				:isLoading="isOTPGettingVerified"
				:disabled="canDisableTheFormFields"
				:error="showErrorMessage"
			/>
		</el-form-item>
	</el-form>
   </RPBasicCardVue>
</template>
<script>
const errorMessages = {
	"Please enter login code": "enterCode",
	"Invalid Code": "invalidCode"
}
import Form from 'element-ui/packages/form';
import FormItem from 'element-ui/packages/form-item';
import LoginFormSuggestionSection from './LoginFormSuggestionSection.vue';
import RPOTPInputField from './RPOTPInputField'
import { mapActions, mapGetters } from 'vuex';
export default {
	props: {
		payload: Object
	},

	data() {
		return {
			userLoginId: '',
			userIdType: 'phone',
			phoneCode: '',
			codeForm: {
				code: ''
			},
			validationRules: {
                code: [
                    { required: true, message: 'Please enter login code', trigger: 'change' },
                ]
			},
			timeLeftForResend: 0,
			resendTimerId: null,
			showErrorMessage: '',
			resetInput: false,
		}
	},

	mounted() {
		this.userLoginId = this.payload.userLoginId.replace(this.payload.phoneCode, '');
		this.userIdType = this.payload.userIdType;
		this.sourcePersonId = this.payload.sourcePersonId
		this.phoneCode = this.payload.phoneCode
		this.setResendTimerId()
	},
	beforeDestroy() {
		if(this.resendTimerId) {
			clearInterval(this.resendTimerId)
		}
	},

	components: {
		[Form.name] : Form,
		[FormItem.name]: FormItem,
		LoginFormSuggestionSection,
		[RPOTPInputField.name]: RPOTPInputField,
	},

	computed: {
		...mapGetters(['errorsInLoginScreen', 'loadersInLoginScreen']),

		isOTPGettingVerified() {
            return this.loadersInLoginScreen('VERIFY_CODE_FOR_LOGIN');
        },

        isErrorOccuredWhileOTPVerification() {
            return this.errorsInLoginScreen('VERIFY_CODE_FOR_LOGIN');
		},
		
		isOTPResending() {
            return this.loadersInLoginScreen('SEND_CODE_FOR_LOGIN');
        },

        isErrorOccuredWhileResendingOTP() {
            return this.errorsInLoginScreen('SEND_CODE_FOR_LOGIN');
		},
		
		canDisableTheFormFields() {
			return this.isOTPGettingVerified || this.isOTPResending
		},

		ctaTextForResendCodeSuggestion() {
			let text = this.$t('loginScreen.resendCode');
			let textIn = this.$t('loginScreen.in');
			return this.timeLeftForResend > 0 ? text+` ${textIn} ${this.timeLeftForResend}s` : text;
		}
	},

	methods: {
		...mapActions(['VERIFY_CODE_FOR_LOGIN', 'SEND_CODE_FOR_LOGIN']),

		async verifyCode(formName) {
			const {
				userLoginId,
				userIdType,
				enteredOTP: code,
				sourcePersonId,
			} = this;

			const { status, message, encryptedData, userProperties } =  await this.VERIFY_CODE_FOR_LOGIN(
				{
					code,
					userLoginId,
					userIdType,
					appClientId: this.$root.configuration.id,
					sourcePersonId
				}
			)
			if(status) {
				this.$emit('loginSuccess', { encryptedData, userProperties })
				return;
			}
			this.showErrorOnButton(message);
		},

		clickedOnChange() {
			this.$emit('clicked-on-change', { userLoginId: this.userLoginId })
		},

		async clickedOnResend() {
			const {
				userLoginId,
				userIdType,
				phoneCode,
			} = this;

			const { status, message, sourcePersonId } =  await this.SEND_CODE_FOR_LOGIN(
				{
					userLoginId,
					userIdType,
					appClientId: this.$root.configuration.id,
					phoneCode,
				}
			)
			this.resetIntputOnError()
			if(status) {
				this.$emit('otp-resent')
				this.setResendTimerId()
				return;
			}
			this.showErrorOnButton(message);
		},

		codeEntered(value) {
			this.enteredOTP = value;
			this.verifyCode('codeForm')
		},

		setResendTimerId() {
			this.timeLeftForResend = 60;

			if(this.resendTimerId) {
				clearInterval(this.resendTimerId)
			}

			this.resendTimerId = setInterval(()=> {
				this.timeLeftForResend -= 1;
				if(!this.timeLeftForResend) {
					clearInterval(this.resendTimerId)
				}
			}, 1000)
		},

		showErrorOnButton(message) {
            if(!message) {
                return;
            }

            this.showErrorMessage = this.$t('errorMessages.'+errorMessages[message]) === 'errorMessages.'+errorMessages[message] ? message : this.$t('errorMessages.'+errorMessages[message])

            setTimeout(() => {
				this.showErrorMessage = '';
			}, 2500)
			this.resetIntputOnError();
		},
		
		resetIntputOnError() {
			this.resetInput = true;
			setTimeout(() => {
                this.resetInput = false;
            }, 0)
		}
	}
}
</script>
<style lang="scss" scoped>
.rp-helpcenter-code-form {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	.rp-helpcenter-code-form__suggestion-text{
		font-size: 19px;
		color: #4d4d4d;
		font-weight: 300;
		&.bold{
			font-weight: 400;
		}
		@include for-size(desktop-up){
			font-size: 23px;
			line-height: 1.6;
		}
	}
	.el-form-item:last-child {
        margin-bottom: 0px;
    }
}
</style>]